import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `EmpresaCentro/imprimirEmpresaCentro`, method: 'POST', body: null, token: token})
}